module.exports = __webpack_public_path__ + "prod/20260903163609/img/logo.1444e71b.png";